import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["as", "hot", "showIcon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames/bind';
import { FireColor } from "../../../../icons";
import { Markup } from "../../../../internal/Markup";
import { TextBase } from "../../../../internal/TextBase";
import { getMethodsForTestId } from "../../../../utils/getMethodsForTestId";
import { NewWindowIcon } from '../NewWindowIcon';
import styles from './MenuCanary.css';
var cx = classNames.bind(styles);

var renderPoint = function renderPoint(key, Component) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return /*#__PURE__*/React.createElement("li", _extends({
    key: key,
    className: cx('item')
  }, props), Component);
};

export var Menu = function Menu(_ref) {
  var content = _ref.content,
      items = _ref.items,
      theme = _ref.theme,
      namespace = _ref.namespace;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'menu'),
      getTestId = _getMethodsForTestId.getTestId,
      getNamespace = _getMethodsForTestId.getNamespace;

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('links', _defineProperty({}, "theme_".concat(theme), theme))
  }, getTestId()), (items === null || items === void 0 ? void 0 : items.length) > 0 && items.map(function renderItem(item, index) {
    if (Array.isArray(item)) {
      return /*#__PURE__*/React.createElement("div", _extends({
        // eslint-disable-next-line react/no-array-index-key
        key: "group_multi_".concat(index),
        className: cx('group_multi')
      }, getTestId(index.toString(), 'multiGroup')), item.map(renderItem));
    }

    var Icon = item.Icon,
        points = item.points,
        text = item.text,
        title = item.title;
    return /*#__PURE__*/React.createElement("div", _extends({
      // eslint-disable-next-line react/no-array-index-key
      key: "group_".concat(index),
      className: cx('group')
    }, getTestId(index.toString(), 'group')), /*#__PURE__*/React.createElement("div", {
      className: cx('heading')
    }, Icon && /*#__PURE__*/React.createElement("div", {
      className: cx('icon')
    }, /*#__PURE__*/React.createElement(Icon, null)), title && /*#__PURE__*/React.createElement(TextBase, {
      as: "span",
      size: "l",
      weight: "semibold",
      namespace: getNamespace('title')
    }, /*#__PURE__*/React.createElement(Markup, {
      text: title
    }))), text && /*#__PURE__*/React.createElement(TextBase, {
      namespace: getNamespace('text')
    }, /*#__PURE__*/React.createElement(Markup, {
      text: text
    })), points && points.length > 0 && /*#__PURE__*/React.createElement("ul", _extends({
      className: cx('group_list')
    }, getTestId('list')), points.map(function (_ref2, pointIndex) {
      var Component = _ref2.as,
          hot = _ref2.hot,
          showIcon = _ref2.showIcon,
          point = _objectWithoutProperties(_ref2, _excluded);

      var componentKey = "point_".concat(pointIndex);

      if (Component) {
        return renderPoint(componentKey, /*#__PURE__*/React.createElement(Component, _extends({
          className: cx('item_link')
        }, point)), _objectSpread({}, getTestId(pointIndex.toString(), 'item')));
      }

      return renderPoint(componentKey, /*#__PURE__*/React.createElement("a", _extends({
        className: cx('item_link', {
          hot: hot
        })
      }, point, getTestId(pointIndex.toString(), 'item', 'link')), /*#__PURE__*/React.createElement(Markup, {
        text: point.title
      }), showIcon && /*#__PURE__*/React.createElement(NewWindowIcon, null), hot && /*#__PURE__*/React.createElement("span", {
        className: cx('hot_icon')
      }, /*#__PURE__*/React.createElement(FireColor, null))), _objectSpread({}, getTestId(pointIndex.toString(), 'item')));
    })));
  }), content && /*#__PURE__*/React.createElement("div", _extends({
    className: cx('group', 'group_content')
  }, getTestId('group')), content));
};